export const LUX_LOGO_URL = 'https://images.luxuryescapes.com/d3d9c6f7-e786-4bb9-aa35-6148dedfb5fa'
